import { Dialog as DialogPrimitive } from '@base-ui/react/dialog';

import { cn } from '@/lib/utils';

export type DialogTitleProps = DialogPrimitive.Title.Props;

const DialogTitle = ({ className, ...props }: DialogTitleProps) => {
  return (
    <DialogPrimitive.Title
      data-slot="dialog-title"
      className={cn('text-[22px] leading-7 font-light', className)}
      {...props}
    />
  );
};

export default DialogTitle;
